import script from "./ProgressButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProgressButton.vue?vue&type=script&lang=ts&setup=true"

import "./ProgressButton.vue?vue&type=style&index=0&id=37708dea&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37708dea"]])

export default __exports__